import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import Layout from './components/layout/Layout';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import ProductPage from './pages/ProductPage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ContactsPage from './pages/ContactsPage';
import CertificatesPage from './pages/CertificatesPage';
import PriceListPage from './pages/PriceListPage';
import WaterPipesPage from './pages/WaterPipesPage';
import SewerPipesPage from './pages/SewerPipesPage';
import GasPipesPage from './pages/GasPipesPage';
import CoextrudedPipesPage from './pages/CoextrudedPipesPage';
import WhatsAppWidget from './components/ui/WhatsAppWidget';

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <LanguageProvider>
          <Router>
            <ScrollToTop />
            <Layout>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/product/:id" element={<ProductPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/contacts" element={<ContactsPage />} />
                <Route path="/certificates" element={<CertificatesPage />} />
                <Route path="/pricelist" element={<PriceListPage />} />
                {/* Redirect old auth routes to home */}
                <Route path="/cart" element={<Navigate to="/" replace />} />
                <Route path="/login" element={<Navigate to="/" replace />} />
                <Route path="/register" element={<Navigate to="/" replace />} />
                <Route path="/profile" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
            <WhatsAppWidget />
          </Router>
        </LanguageProvider>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
